let aacpVi = {
    "pinned": [
      "Id"
    ],
    "width": {
      "Deal": 240,
      "WireDate": 94
    },
    "immutable": {
      "Total": true,
      "CashBalance": true,
      "CKGBalance": true,
      "Id": true
    },
    "mapping": {
      "Id": {
        "header": "Id",
        "rules": null,
        "dataType": "Int",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Id"
      },
      "Deal": {
        "header": "Deal",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Deal",
        "cellEditor": "agTextCellEditor"
      },
      "WireDate": {
        "header": "Wire Date",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "WireDate"
      },
      "NoMMA": {
        "header": "No MMA",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "NoMMA",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "BalancedCKG": {
        "header": "Checking",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "BalancedCKG",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "Total": {
        "header": "Total",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Total",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      // "FRBLoc": {
      //   "header": "FRB LOC",
      //   "rules": null,
      //   "dataType": "text",
      //   "meta": null,
      //   "palceholder": null,
      //   "validations": null,
      //   "col": "FRBLoc",
      //   "textAlign": 'right',
      //   "cellEditor": "agTextCellEditor"
      // },
      "CashBalance": {
        "header": "Cash Balance",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CashBalance",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "CKGBalance": {
        "header": "Checking Balance",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "CKGBalance",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "AutomatedComments": {
        "header": "Automated Comments",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "AutomatedComments",
        "cellEditor": "agTextCellEditor"
      },
      "TiesToBank": {
        "header": "Ties to Bank",
        "rules": null,
        "dataType": "date",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "TiesToBank",
        "cellEditor": "agTextCellEditor"
      },
      "Notes": {
        "header": "Notes",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "Notes",
        "cellEditor": "agTextCellEditor"
      },
      "FXRate": {
        "header": "FX Rate",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FXRate",
        "textAlign": 'right',
        "cellEditor": "agTextCellEditor"
      },
      "FXRateDate": {
        "header": "Date of FX Rate",
        "rules": null,
        "dataType": "text",
        "meta": null,
        "palceholder": null,
        "validations": null,
        "col": "FXRateDate"
      }
    }
  }
  export  { aacpVi }
  